angular.module('dnecom')
    .controller('ColorNameModalController', ["$scope", "$uibModalInstance", "colorName", function ($scope, $uibModalInstance, colorName) {
        $scope.color = {
            name: colorName
        };

        $scope.submit = function() {
            $uibModalInstance.close($scope.color.name);
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
